import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import {MdClose} from "react-icons/md";
import React from "react";
import Button from "../Button";
const SuccessStageModal=({onConfirm,title,description,subTitle,showIcon=true,showTitle=true,nextStepText='مرحله بعد',theme,options})=>{

    const handleClose=()=>{

    }
    const handleClick=(char)=>{
        onConfirm();
        Reoverlay.hideModal();
    }
    return <ModalWrapper  onClose={handleClose}  animation="zoom" contentContainerClassName="w-11/12 md:w-5/12  bg-gray-50 lg:w-4/12 p-5 rounded-xl">
                <div className="flex justify-center flex-col items-center">
                    {showIcon &&   <svg  xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 222 222">
                        <g id="Group_1" data-name="Group 1" transform="translate(-854 -306)">
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx="111" cy="111" r="111" transform="translate(854 306)" fill="#ecfcf2"/>
                            <path id="verify-svgrepo-com_1_" data-name="verify-svgrepo-com (1)" d="M153.187,69.585,142.673,57.37a17.135,17.135,0,0,1-3.634-9.741V34.486a14.98,14.98,0,0,0-14.921-14.921H110.976a17.342,17.342,0,0,1-9.741-3.634L89.019,5.417a15.579,15.579,0,0,0-19.482,0L57.4,16.009a17.835,17.835,0,0,1-9.741,3.556H34.283A14.98,14.98,0,0,0,19.362,34.486v13.22a17.592,17.592,0,0,1-3.556,9.664L5.369,69.662a15.566,15.566,0,0,0,0,19.328l10.437,12.292a17.592,17.592,0,0,1,3.556,9.664v13.22a14.98,14.98,0,0,0,14.921,14.921H47.658a17.342,17.342,0,0,1,9.741,3.634l12.215,10.514a15.579,15.579,0,0,0,19.482,0l12.215-10.514a17.135,17.135,0,0,1,9.741-3.634H124.2a14.98,14.98,0,0,0,14.921-14.921V111.024a17.342,17.342,0,0,1,3.634-9.741l10.514-12.215A15.684,15.684,0,0,0,153.187,69.585ZM111.44,64.715,74.1,102.056a5.786,5.786,0,0,1-8.195,0L47.194,83.346a5.795,5.795,0,0,1,8.195-8.195L70,89.763l33.244-33.244a5.795,5.795,0,1,1,8.195,8.2Z" transform="translate(885.688 337.674)" fill="#30b271"/>
                        </g>
                    </svg>}
                    {showTitle &&  <h1 className="text-green-500 text-center text-2xl">{title}</h1>}
                    <h1 className="text-xl  text-center">{subTitle}</h1>
                    <p className="text-sm text-center mt-2 mb-5">{description}</p>
                    <div className="grid-cols-1 grid w-full">
                        <Button onClick={handleClick} rounded="rounded-lg" className="w-full" theme={theme ? theme:"blue"}>{nextStepText? nextStepText:"تایید"}</Button>
                    </div>
                </div>

            </ModalWrapper>
}
export default SuccessStageModal;